import {PdsImage} from '../interfaces/pds-image';
import {ImageOrientation} from '../models/image-orientation';

export class ImageController {
  private image: PdsImage;
  constructor(img: PdsImage) {
    this.image = img;
  }
  getImage():  PdsImage {
    return this.image;
  }
  setImage(img: PdsImage): void {
    this.image = img;
  }
  getImageOrientation(imageOrientationCallback: (imageOrientation: ImageOrientation) => void): void {
    this.loadImage((img: HTMLImageElement) => {
      let imageOrientation = (img.width > img.height) ? 'HORIZONTAL' : (img.width < img.height)  ? 'VERTICAL' : 'EVEN';
      imageOrientationCallback(<ImageOrientation>imageOrientation);
    });
  }
  loadImage(imageOnLoadCallback: (img) => void): void {
    let img = new Image();
    img.src = this.image.src;
    img.onload = () => {
      imageOnLoadCallback(img);
    };
  }
}
